<div *ngIf="prize.PrizeType == prizeType.PrizeDrawEntry">
  <div class="fgbcl-game-result-prize-container">
    <div *ngIf="prize.Image">
      <img class="fgbcl-game-result-prize-image" [src]="prize.Image | contentImage: '7'" alt="{{ prize.Name }}" />
    </div>
    <div class="fgbcl-game-result-prize-text-section">
      <div class="fgbcl-game-result-prize-text">
        {{ 'fgbcl.game.result.prize.draw.entered.text' | translate }}
      </div>
      <div class="fgbcl-game-result-prize-description-text">
        {{ prize.Name }}
      </div>
    </div>
  </div>
</div>
